import Aos from "aos"
import { useEffect } from "react"

export const useAos= (duration) => {
    useEffect(
        function( ) {
            Aos.init({ duration })
        }
    )
}